// extracted by mini-css-extract-plugin
export default {"closeMenuBtn":"CloseMenuBtn_closeMenuBtn__0nraf"};